import React from "react";

import TemplateIndex from "../../components/TemplateIndex";
import { ICardMenu } from "../../components/CardMenu";

const Report: React.FC = () => {
    const items: ICardMenu[] = [
        {
            path: "/summarymonthgs",
            icon: "dollar",
            text: "Ganho G.S",
            roles: ["Admin","Operador"],
            show: false
        },
        {
            path: "/partialmonth",
            icon: "money bill alternate",
            text: "Previsão Entradas",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/partialmonthsector",
            icon: "money bill alternate",
            text: "Previsão Entradas",
            roles: ["GerenteS"],
            show: true
        },
        {
            path: "/paymentsconference",
            icon: "check circle",
            text: "Conferir Entradas",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/agentopened",
            icon: "tachometer alternate",
            text: "Acompanhemento Kit",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/agentproductivitymonth",
            icon: "chart line",
            text: "Produtividade R.P",
            roles: ["GerenteS"],
            show: true
        },
        {
            path: "/prevision",
            icon: "question circle",
            text: "Previsão de Acertos",
            roles: ["Admin", "Operador","GerenteS"],
            show: true
        },
        {
            path: "/sectorproductivity",
            icon: "chart area",
            text: "Produtividade G.S",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/topsales",
            icon: "numbered list",
            text: "Ranking de Vendas",
            roles: ["Admin", "Operador","GerenteS"],
            show: true
        },
        {
            path: "/opened",
            icon: "folder open outline",
            text: "Kit's em aberto",
            roles: ["Admin", "Operador","GerenteS"],
            show: true
        },
        {
            path: "/agenthistory",
            icon: "line graph",
            text: "Produtividade R.P",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/agentmonth",
            icon: "user plus",
            text: "Cadastros R.P",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/agentperformance",
            icon: "line graph",
            text: "Meu Desempenho",
            roles: ["Admin", "Representante"],
            show: true
        },
        {
            path: "/conferencesbyagent",
            icon: "pie graph",
            text: "Conf. por Kit",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/debts",
            icon: "user times",
            text: "Devedores",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/notreturned",
            icon: "thumbs down",
            text: "Não Retornaram",
            roles: ["Admin", "Operador"],
            show: true
        },
    ];

    return <TemplateIndex title="Relatórios" cards={items} />;
}

export default Report;
